import { Delete, RotateCcw } from 'lucide-react';

type Props = { value: string; onChange: (value: string) => void };
export function CashKeypad({ value, onChange }: Props) {
  const append = (key: string) => {
    if (key === 'clear') return onChange('');
    if (key === 'back') return onChange(value.slice(0, -1));
    if (key === '.' && value.includes('.')) return;
    if (key === '.' && value === '') return onChange('0.');
    if (value.includes('.') && value.split('.')[1]!.length >= 2 && key !== '.') return;
    if (value === '0' && key !== '.') return onChange(key);
    onChange(value + key);
  };
  return (
    <div className="grid grid-cols-3 gap-2">
      {['1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '0', 'back'].map((key) => (
        <button
          key={key}
          type="button"
          onClick={() => append(key)}
          className="min-h-[64px] rounded-xl border border-slate-200 bg-white text-xl font-black text-[#003B70] shadow-sm active:scale-[0.98]"
        >
          {key === 'back' ? <Delete className="mx-auto" size={22} aria-hidden="true" /> : key}
        </button>
      ))}
      <button
        type="button"
        onClick={() => append('clear')}
        className="col-span-3 flex min-h-[56px] items-center justify-center gap-2 rounded-xl border border-red-100 bg-red-50 text-sm font-extrabold text-red-600"
      >
        <RotateCcw size={17} /> Clear
      </button>
    </div>
  );
}
